import { get, map } from 'lodash';

import Model from 'models';

import Level1Node from './Level1Node';

const TopNavigation = class extends Model {
  get id() {
    return get(this._data, 'id');
  }

  get subNavigations() {
    return map(get(this._data, 'subNavigations'), node => new Level1Node(node));
  }
};

export default TopNavigation;
